"use strict";
exports.__esModule = true;
exports.PORTAL_SIGN_IN = void 0;
exports.PORTAL_SIGN_IN = {
    BODY: 'Flex integrates with {{fallBackPropertyName}} through {{fallbackPortalDisplayName}}. Connect to {{fallbackPortalDisplayName}} to authorize Flex to pay your rent each month.',
    BODY_WEB: 'Flex integrates with {{fallBackPropertyName}} through {{fallbackPortalDisplayName}}. Connect to {{fallbackPortalDisplayName}} to authorize Flex to pay your rent each month.',
    FORGOT_PASSWORD: 'Forgot {{portalDisplayName}} password?'
};
